import { useLayoutEffect, useState, useRef } from 'react';
import { ThemeContext } from '../../../constants/themes';
import Loader from '../../atoms/Loader';
import Button from '../../atoms/Button';
import Type from '../../atoms/Type';
import { validURL } from '../../../utils/strings';
import './index.css';
  
const TextSubmit = ({ buttonText, disabled, forceErrorState, isLoading, readonly, initialValue, style, onSubmit, placeholder, type }) => {
   const [state, setState] = useState({
      value: '',
      buttonText: buttonText || 'Submit',
      errorState: false
   });

   useLayoutEffect(() => {
      setState({
         ...state,
         buttonText: buttonText || 'Submit',
         value: initialValue || ''
      });
   }, [buttonText, readonly, initialValue, style, onSubmit, placeholder, type ])

   const inputRef = useRef(null);

   const copyToClipboard = (e) => {
      inputRef.current.select();
      document.execCommand('copy');
      e.target.focus();
      setState({
         ...state,
         buttonText: 'Copied',
         errorState: false
      });
    }

   const onChange = (evt) => {
      setState({
         ...state,
         value: evt.target.value
      })
   }

   const submitFunc = (e) => {
      if (state.value !== '') {
         if (type === 'url' && validURL(state.value)) {
            onSubmit(state.value);
            setState({
               ...state,
               errorState: false
            });
         } else if (type === 'copy') {
            copyToClipboard(e);
         } else {
            setState({
               ...state,
               errorState: true
            });
         }
      } else {
         setState({
            ...state,
            errorState: true
         });
      }
   }

   return (
      <ThemeContext.Consumer>
         {themeContext => (
            <>
               <div className="textsubmit-div" style={{backgroundColor: themeContext.theme.body, borderColor: themeContext.theme.text, ...style}}>
                  <input ref={inputRef} style={{color: themeContext.theme.text}} readOnly={readonly || disabled || isLoading ? 'readonly' : false} className="textsubmit-input" type="text" placeholder={placeholder} onChange={onChange} value={state.value}/>
                  {!isLoading ?
                     <Button disabled={disabled} value={state.buttonText} onClick={submitFunc}/>
                     :
                     <div>
                        <Loader />
                     </div>
                  }
               </div>
               { state.errorState || forceErrorState ?
                  <Type type="caption">Please enter a valid URL ヽ(｀δ´)ノ</Type>
                  :
                  null
               }
            </>
         )}
      </ThemeContext.Consumer>
   );
}
  
export default TextSubmit;